// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"37080719","455":"8405d007","977":"f4921d12"}[chunkId] + ".chunk.js";
};